import axios from 'axios'

// Version des Stands aus dem Ergebnis-Link (#/ergebnisse/?v=…): ein alter
// Link laedt seinen alten Stand (Spec 2026-10-06, 3.5). Jedes vorhandene v ist
// ein Wunsch nach genau diesem Stand, auch ein beschaedigtes — der Server
// kennt es nicht (404), und die Seite sagt das, statt still den aktuellen
// Stand zu zeigen (Final Review I1).
export const versionFromLocation = (hash) => {
    const params = new URLSearchParams((hash || '').split('?')[1] || '')
    return params.has('v') ? params.get('v') : null
}

// Lädt den eingefrorenen Matrix-Snapshot vom server-matrix — mit Version im
// Link genau diesen Stand. 404 (kein Snapshot / noch nicht freigeschaltet /
// Stand nicht mehr da) → null.
const fetchSnapshot = async (apiUrl, mappingId) => {
    if (!mappingId || !apiUrl) {
        return null
    }

    const version = versionFromLocation(window.location.hash)
    try {
        const res = await axios({ method: 'GET', url: `${apiUrl}/matrix/${mappingId}${null === version ? '' : `?v=${encodeURIComponent(version)}`}` })
        return res.data
    } catch (e) {
        if (e.response?.status === 404) return null
        throw e
    }
}

// Shortcode-Weg: Container trägt mappingId und apiUrl als data-Attribute.
export async function loadSnapshot(el) {
    const { mappingId, apiUrl } = el.dataset
    return fetchSnapshot(apiUrl, mappingId)
}

// Kachel-Weg der öffentlichen Event-App: die Mapping-ID kommt aus dem Event,
// die API-Basis aus wp_localize_script (Spec Abschnitt 9).
export async function loadSnapshotById(mappingId) {
    if (!mappingId) return null
    return fetchSnapshot(matrixPublicParams.api_url, mappingId)
}
